

import a from './IMG_1476.JPG'
import b from './IMG_1479.JPG'
import c from './IMG_1480.JPG'

const DemoArray = [a,b,c]
export {DemoArray}